/**
 * @generated SignedSource<<6e08996fdf08bbf5749380de89acbd79>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeletePropertySearchInput = {
  clientMutationId?: string | null;
  id: string;
};
export type propertySearchDrawerDeleteMutation$variables = {
  input: DeletePropertySearchInput;
};
export type propertySearchDrawerDeleteMutation$data = {
  readonly deletePropertySearch: {
    readonly deletedPropertySearchId: string | null;
  } | null;
};
export type propertySearchDrawerDeleteMutation = {
  response: propertySearchDrawerDeleteMutation$data;
  variables: propertySearchDrawerDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeletePropertySearchPayload",
    "kind": "LinkedField",
    "name": "deletePropertySearch",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedPropertySearchId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "propertySearchDrawerDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "propertySearchDrawerDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "0bae37b881f118513676491b99d039bd",
    "id": null,
    "metadata": {},
    "name": "propertySearchDrawerDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation propertySearchDrawerDeleteMutation(\n  $input: DeletePropertySearchInput!\n) {\n  deletePropertySearch(input: $input) {\n    deletedPropertySearchId\n  }\n}\n"
  }
};
})();

(node as any).hash = "51fa3bfd7e5844a1754568d28209c4bf";

export default node;
